








































































































import Vue from 'vue';
import { mapGetters, mapState } from 'vuex';
import pxButton from '@/dex-shared/components/px-button.vue';
import pxCard from '@/dex-shared/components/px-card.vue';
import moment from 'moment';

import { Parser } from 'json2csv';

moment.locale('pt-BR');

export default Vue.extend({
  components: {
    pxButton,
    pxCard,
  },
  data: function() {
    return {
      schoolId: null,
      managersAreBeingSearched: false,
      newManagerEmail: null,
      userAreBeingSearched: null,
      addingNewManager: false,
      removingManager: false,
    };
  },
  computed: {
    ...mapState({
      schoolManagers: (state: any) => state.users.schoolManagers,
      userToBeManager: (state: any) => state.users.userToBeManager,
      schoolFoundButNoManager: (state: any) =>
        state.users.schoolFoundButNoManager,
    }),
  },
  destroyed() {
    this.$store.commit('SCHOOL_FOUND_BUT_NO_MANAGERS', false);
  },
  methods: {
    async searchManager() {
      if (!this.schoolId) {
        alert('O campo de ID está nulo.');
        return null;
      }
      this.managersAreBeingSearched = true;
      await this.$store.dispatch(
        'PULL_SCHOOL_MANAGERS',
        parseInt(this.schoolId),
      );
      this.managersAreBeingSearched = false;
    },
    async searchUser() {
      if (!this.newManagerEmail) {
        alert('O campo de email está nulo.');
        return null;
      }
      this.userAreBeingSearched = true;
      await this.$store.dispatch(
        'PULL_USER_TO_BE_MANAGER',
        this.newManagerEmail,
      );
      this.userAreBeingSearched = false;
    },
    async addNewManager(manager) {
      if (!manager) {
        alert('Usuário nulo.');
        return;
      }
      const managerAlreadyExists =
        this.schoolManagers.filter(
          schoolManager => schoolManager.email === manager.email,
        ).length > 0;
      if (managerAlreadyExists) {
        alert('Esse usuário já é um gestor.');
        return;
      }
      this.addingNewManager = true;
      await this.$store.dispatch('PUSH_NEW_MANAGER', {
        manager,
        classroomId: parseInt(this.schoolId),
      });
      this.addingNewManager = false;
      this.newManagerEmail = null;
    },
    async removeManager(manager) {
      if (!manager) {
        alert('Usuário nulo.');
        return;
      }
      this.removingManager = true;
      await this.$store.dispatch('REMOVE_MANAGER', manager.staffId);
      this.removingManager = false;
    },
  },
});
